import React from "react";
import { MOBILE_NAV_ACTIVE, MOBILE_NAV_HEIGHT, MOBILE_NAV_INACTIVE } from "./constants";

export default function MobileBottomNavStyles() {
  return (
    <style>{`
      .sv-mobile-nav {
        display: none;
      }
      @media (max-width: 991px) {
        .sv-mobile-nav {
          display: flex;
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 200;
          height: ${MOBILE_NAV_HEIGHT}px;
          padding-bottom: env(safe-area-inset-bottom, 0);
          background: var(--app-surface);
          border-top: 1px solid var(--app-border);
          align-items: stretch;
          justify-content: space-around;
        }
        .sv-mobile-nav__item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          border: none;
          background: transparent;
          padding: 6px 4px 4px;
          color: ${MOBILE_NAV_INACTIVE};
          cursor: pointer;
          position: relative;
          min-width: 0;
        }
        .sv-mobile-nav__item--active {
          color: ${MOBILE_NAV_ACTIVE};
        }
        .sv-mobile-nav__icon {
          font-size: 22px;
          line-height: 1;
        }
        .sv-mobile-nav__label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.04em;
          line-height: 1.2;
        }
        .sv-mobile-nav__indicator {
          position: absolute;
          bottom: 2px;
          left: 50%;
          transform: translateX(-50%);
          width: 28px;
          height: 3px;
          border-radius: 2px;
          background: ${MOBILE_NAV_ACTIVE};
        }
        .app-main--mobile-nav {
          padding-bottom: calc(${MOBILE_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px));
        }
        .mobile-fab {
          display: none !important;
        }
      }
      @media (min-width: 992px) {
        .mobile-fab {
          display: none !important;
        }
      }
    `}</style>
  );
}
